<template>
  <div class="">

    <div class="fixed top-0 left-0 right-0 p-2 overflow-y-auto text-xs bg-white border-b custom-scroll">
      <div class="max-w-sm mx-auto">
      <div class="flex justify-between">
        <div class="">
          <label style="font-size: 10px;" class="block font-bold tracking-wide text-gray-600 uppercase whitespace-no-wrap">Select Root Note</label>
           <select class="w-full p-2 mt-1 text-sm bg-white border rounded" v-model="rootNote">
             <option
               :key="index"
               v-for="(notes, index) in allNotes"
               :value="useFlats && notes[1] ? notes[1].name() + notes[1].accidental() : notes[0].name() + notes[0].accidental()"
             >
               {{formatChord(notes[0].name() + notes[0].accidental())}}
               <span v-if="notes[1]"> / {{formatChord(notes[1].name() + notes[1].accidental())}}</span>
             </option>
           </select>
        </div>

        <div class="flex-1 ml-3">
          <label style="font-size: 10px;" class="block font-bold tracking-wide text-gray-600 uppercase whitespace-no-wrap">Select Scale Type</label>
          <select class="w-full p-2 mt-1 text-sm bg-white border rounded" v-model="scaleType">
            <option value="major">Major</option>
            <option value="natural_minor">Natural Minor</option>
            <option value="harmonic_minor">Harmonic Minor</option>
            <option value="melodic_minor">Melodic Minor</option>
          </select>
        </div>

        <div class="flex flex-col justify-end pr-2 ml-3">
          <div class="">
            <label style="font-size: 10px;" class="flex justify-between font-bold tracking-wide text-gray-600 uppercase whitespace-no-wrap cursor-pointer">
              <span>Use Flats?</span>
              <input type="checkbox" class="p-2 ml-2 bg-white border rounded cursor-pointer" v-model="useFlats"></label>
          </div>

          <div class="mt-2">
            <label style="font-size: 10px;" class="flex justify-between font-bold tracking-wide text-gray-600 uppercase whitespace-no-wrap cursor-pointer">Use Jazz Symbols?
              <input type="checkbox" class="p-2 ml-2 bg-white border rounded cursor-pointer" v-model="useJazzSymbols"></label>
          </div>
        </div>
      </div>
    </div>
    </div>

    <div class="mt-20">
      <ScaleFormula
        :currentScale="currentScale"
        :formatChord="formatChord"
      />
    </div>

    <div class="mt-4">
      <RelatedChords
        :majorSevenSymbol="useJazzSymbols ? '∆' : 'maj7'"
        :minorSymbol="useJazzSymbols ? '-' : 'm'"
        :minorSevenSymbol="useJazzSymbols ? '-7' : 'm7'"
        :diminishedSymbol="useJazzSymbols ? '˚' : 'dim7'"
        :rootNote="rootNote"
        :scaleType="scaleType"
        :formatChord="formatChord"
      />
    </div>

    <div class="mt-4">
      <ChromaticMediants
        :rootNote="rootNote"
        :scaleType="scaleType"
        :minorSymbol="useJazzSymbols ? '-' : 'm'"
        :formatChord="formatChord"
      />
    </div>

    <div class="mt-4">
      <ChordsByCommonality
        :rootNote="rootNote"
        :scaleType="scaleType"
        :minorSymbol="useJazzSymbols ? '-' : 'm'"
        :formatChord="formatChord"
      />
    </div>
  </div>
</template>

<script>
import teoria from "teoria";
import ChordsByCommonality from "../components/ChordsByCommonality.vue";
import RelatedChords from "../components/RelatedChords.vue";
import ScaleFormula from "../components/ScaleFormula.vue";
import ChromaticMediants from "../components/ChromaticMediants.vue";
const note = teoria.note;
const scale = teoria.scale;

export default {
  name: "Home",
  data() {
    return {
      rootNote: "c",
      scaleType: "major",
      useJazzSymbols: false,
      useFlats: false,
    };
  },
  components: {
    RelatedChords,
    ChromaticMediants,
    ChordsByCommonality,
    ScaleFormula
  },
  methods: {
    formatChord(chord) {
      if(typeof chord === 'object') {
        chord = chord.name;
      }
      chord = chord.charAt(0).toUpperCase() + chord.slice(1);
      return chord
        .replace("b", "♭")
        .replace("#", "♯")
        .replace("aug", this.augmentedSymbol)
        .replace("mM7", this.minorMajorSevenSymbol)
        .replace(/dim$/, this.useJazzSymbols ? this.diminishedSymbol : "dim")
        .replace("dim7", this.diminishedSymbol)
        .replace("maj7", this.majorSevenSymbol)
        .replace("m7", this.minorSevenSymbol)
        .replace("m", this.minorSymbol)
    },
  },
  watch: {
    useFlats() {
      var currentRoot = teoria.note.fromString(this.rootNote);
      if(!currentRoot.accidental()) return;

      var enharmonic = currentRoot.enharmonics(true);
      this.rootNote = enharmonic[0].name() + enharmonic[0].accidental();
    }
  },
  computed: {
    allNotes() {
      return [
        [teoria.note.fromString("a4")],
        [teoria.note.fromString("a#4"), teoria.note.fromString("bb4")],
        [teoria.note.fromString("b4")],
        [teoria.note.fromString("c4")],
        [teoria.note.fromString("c#4"), teoria.note.fromString("db4")],
        [teoria.note.fromString("d4")],
        [teoria.note.fromString("d#4"), teoria.note.fromString("eb4")],
        [teoria.note.fromString("e4")],
        [teoria.note.fromString("f4")],
        [teoria.note.fromString("f#4"), teoria.note.fromString("gb4")],
        [teoria.note.fromString("g4")],
        [teoria.note.fromString("g#4"), teoria.note.fromString("ab4")],
      ];
    },
    currentScale() {
      const scales = {
        major: {
          formula: {
            degree: [1, 2, 3, 4, 5, 6, 7, 8],
            degree_name: ["Tonic", "Supertonic", "Mediant", "Subdominant", "Dominant", "Submediant", "Leading Tone", "Octave/Tonic"],
            names: ["R", "M2", "M3", "P4", "P5", "M6", "M7", "R"],
            interval_us: ["W", "W", "H", "W", "W", "W", "H"],
            interval_uk: ["T", "T", "S", "T", "T", "T", "S"],
          },
          scale: this.majorScale
        },
        natural_minor: {
          formula: {
            degree: [1, 2, "♭3", 4, 5, "♭6", "♭7", 8],
            degree_name: ["Tonic", "Supertonic", "Mediant", "Subdominant", "Dominant", "Submediant", "Leading Tone", "Octave/Tonic"],
            names: ["R", "M2", "m3", "P4", "P5", "m6", "m7", "R"],
            interval_us: ["W", "H", "W", "W", "H", "W", "W"],
            interval_uk: ["T", "S", "T", "T", "S", "T", "T"],
          },
          scale: this.minorScale
        },
        harmonic_minor: {
          formula: {
            degree: [1, 2, "♭3", 4, 5, "♭6", 7, 8],
            degree_name: ["Tonic", "Supertonic", "Mediant", "Subdominant", "Dominant", "Submediant", "Leading Tone", "Octave/Tonic"],
            names: ["R", "M2", "m3", "P4", "P5", "m6", "M7", "R"],
            interval_us: ["W", "H", "W", "W", "H", "3H", "H"],
            interval_uk: ["T", "S", "T", "T", "S", "3S", "S"],
          },
          scale: this.harmonicMinorScale
        },
        melodic_minor: {
          formula: {
            degree: [1, 2, "♭3", 4, 5, 6, 7, 8],
            degree_name: ["Tonic", "Supertonic", "Mediant", "Subdominant", "Dominant", "Submediant", "Leading Tone", "Octave/Tonic"],
            names: ["R", "M2", "m3", "P4", "P5", "M6", "M7", "R"],
            interval_us: ["W", "H", "W", "W", "W", "W", "H"],
            interval_uk: ["T", "S", "T", "T", "T", "T", "S"],
          },
          scale: this.melodicMinorScale
        },
      };
      return scales[this.scaleType];
    },
    majorSevenSymbol() {
      return this.useJazzSymbols ? '∆' : 'maj7';
    },
    minorMajorSevenSymbol() {
      return this.useJazzSymbols ? '-∆' : 'mM7';
    },
    augmentedSymbol() {
      return this.useJazzSymbols ? '+' : 'aug';
    },
    minorSymbol() {
      return this.useJazzSymbols ? '-' : 'm';
    },
    minorSevenSymbol() {
      return this.useJazzSymbols ? '-7' : 'm7';
    },
    diminishedSymbol() {
      return this.useJazzSymbols ? '˚' : 'dim7';
    },
    chromaticScale() {
      return scale(note("a4"), "chromatic");
    },
    majorScale() {
      return scale(note(this.rootNote), "major");
    },
    minorScale() {
      return scale(note(this.rootNote), "minor");
    },
    harmonicMinorScale() {
      return scale(note(this.rootNote), "harmonicminor");
    },
    melodicMinorScale() {
      return scale(note(this.rootNote), "melodicminor");
    }
  }
};
</script>
